// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1vKjJ","list":"PatternAutocomplete_list__2rrB0"};